import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import { QueryClient } from "@tanstack/react-query";
import { REACT_QUERY_PERSIST_KEY } from "@/lib/constants";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      gcTime: 24 * 60 * 60 * 1000,
    },
  },
});

export const queryPersister = createAsyncStoragePersister({
  storage: window.localStorage,
  key: REACT_QUERY_PERSIST_KEY,
});
